import { createFileRoute } from '@tanstack/react-router';
import { AdminPostingsPage } from '@/pages/staffing/AdminPostingsPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { z } from 'zod';

const searchSchema = z.object({
	page: z.coerce.number().int().positive().optional(),
	status: z.enum(['ACTIVE', 'DRAFT', 'CLOSED', 'EXPIRED']).optional(),
});

export const Route = createFileRoute('/_authenticated/_app/chain/staffing')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['staffing.managePostings'], redirectTo: '/dashboard' }),
	validateSearch: searchSchema,
	component: AdminPostingsPage,
});
